export type ActionPlanStep = 'none' | 'focus' | 'selection' | 'thankYou' | 'aggregated';

/** Det brukeren valgte, vist på takkesiden */
export interface ActionPlanChoices {
  commitment: string;
  expectation: string;
}

export interface ActionPlanFlowState {
  currentStep: ActionPlanStep;
  selectedCategoryId: number;
  submittedChoices?: ActionPlanChoices;
}

export class ActionPlanFlowManager {
  public static getInitialState(): ActionPlanFlowState {
    return {
      currentStep: 'focus',
      selectedCategoryId: 0,
    };
  }

  public static handleFocusContinue(
    state: ActionPlanFlowState,
    categoryId: number,
  ): ActionPlanFlowState {
    return {
      ...state,
      currentStep: 'selection',
      selectedCategoryId: categoryId,
    };
  }

  public static handleSelectionSuccess(
    state: ActionPlanFlowState,
    submittedChoices?: ActionPlanChoices,
  ): ActionPlanFlowState {
    return {
      ...state,
      currentStep: 'thankYou',
      submittedChoices,
    };
  }

  public static handleSelectionBack(
    state: ActionPlanFlowState,
  ): ActionPlanFlowState {
    return {
      ...state,
      currentStep: 'focus',
    };
  }

  public static reset(): ActionPlanFlowState {
    return this.getInitialState();
  }
}
